export default "__VITE_ASSET__DJGn5ms6__"